import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RequiredDocument, RequiredDocumentFileUploadModel } from '../../model/application-form.model';
import { AppUppyFile } from "common";
import { ApplicationFormFacade } from '../application-form/application-form.facade';
import { MAX_UPLOAD_FILES_COUNT } from '../progress-bar-dialog/document-upload-uppy-config';

@Component({
    selector: 'ifm-required-documents-application',
    templateUrl: './required-documents-application.component.html',
    styleUrls: ['./required-documents-application.component.scss'],
    standalone: false
})
export class RequiredDocumentsApplicationComponent implements OnChanges {

  @Input() documents: RequiredDocument[];
  @Input() parentObjectId: number;
  @Output() filesToUploadChanged = new EventEmitter<RequiredDocumentFileUploadModel[]>();

  public totalRequiredDocumentsCount = 0;
  public maxFilesTotalCount = MAX_UPLOAD_FILES_COUNT;
  public remainingFilesCount = MAX_UPLOAD_FILES_COUNT;
  public maxFilesByDocumentId: Record<number, number> = {};

  private filesToUpload: RequiredDocumentFileUploadModel[] = [];

  constructor(private facade: ApplicationFormFacade) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.documents?.currentValue) {
      this.documents = changes.documents.currentValue;
      this.recalculateTotalRequiredDocumentsCount();
      this.recalculateMaxFilesByDocumentId();
    }
  }

  private recalculateTotalRequiredDocumentsCount() {
    this.totalRequiredDocumentsCount = this.documents?.reduce((a, b) => a + b?.requiredDocumentsCount, 0);
  }

  public onDocumentFilesChanged(minimalLeadDocument: RequiredDocument, newFiles: AppUppyFile[]) {
    this.filesToUpload = this.facade.attachFilesToUpload(minimalLeadDocument, newFiles, this.filesToUpload);
    this.recalculateMaxFilesByDocumentId();
    this.filesToUploadChanged.emit(this.filesToUpload);
  }

  private recalculateMaxFilesByDocumentId(): void {
    const stagedCountByDocumentId: Record<number, number> = {};
    this.filesToUpload.forEach(
      (f) => (stagedCountByDocumentId[f.requiredDocument.id] = f.filesToUpload?.length ?? 0)
    );
    const stagedTotalCount = this.filesToUpload.reduce(
      (total, f) => total + (f.filesToUpload?.length ?? 0), 0
    );

    this.remainingFilesCount = MAX_UPLOAD_FILES_COUNT - stagedTotalCount;
    this.maxFilesByDocumentId = {};
    this.documents?.forEach((document) => {
      this.maxFilesByDocumentId[document.id] =
        this.remainingFilesCount + (stagedCountByDocumentId[document.id] ?? 0);
    });
  }
}
